import styled from 'styled-components';
import { Accordion } from 'ui/accordion/Accordion';

export const StyledAccordion = styled(Accordion)`
  padding: 0;
  background-color: transparent;
`;
